"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function SvgComponent(props) {
    return (React.createElement(react_native_svg_1.default, Object.assign({ width: 19, height: 13, viewBox: "0 0 19 13", fill: "none" }, props),
        React.createElement(react_native_svg_1.Path, { d: "M9.167 0C5 0 1.442 2.592 0 6.25c1.442 3.658 5 6.25 9.167 6.25 4.166 0 7.725-2.592 9.166-6.25-1.441-3.658-5-6.25-9.166-6.25zm0 10.417A4.168 4.168 0 015 6.25c0-2.3 1.867-4.167 4.167-4.167s4.166 1.867 4.166 4.167-1.866 4.167-4.166 4.167zm0-6.667a2.497 2.497 0 00-2.5 2.5c0 1.383 1.116 2.5 2.5 2.5 1.383 0 2.5-1.117 2.5-2.5s-1.117-2.5-2.5-2.5z", fill: "#436EAC" })));
}
exports.default = SvgComponent;
